import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";


export default function WarehouseView() {
  const { id } = useParams();
  const [row, setRow] = useState(null);
  const language = useUserLanguage();
const { translations } = useTranslations(language);
const getText = (key, def) => translations[key] || def;


  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/warehouses/${id}`).then(res => {
      setRow(res.data);
    });
  }, [id]);

  if (!row) return getText("LOADING_SETTINGS");

  return (
    <div className="container card p-4 mt-4">

      <p><strong>{getText("WAREHOUSE_NAME_LABEL")}:</strong> {row.title}</p>
      <p><strong>{getText("STATUS_LABEL")}:</strong> {row.status === "active"
          ? getText("STATUS_ACTIVE")
          : getText("STATUS_PASSIVE")}</p>
    </div>
  );
}
